module.exports = ( settings ) ->
  root = settings.API_ROOT
  rpcRoot = "#{root}rpc/"
  twain = settings.TWAIN_SERVICE

  return {
    WorkflowTemplate: "#{root}workflow_templates/"
    Workflow: "#{root}workflows/"
    WorkflowEncryptedMetadata: "#{root}workflows_encrypted_metadata/"
    WorkflowStepConfig: "#{root}workflow_step_configs/"
    StepModifier: "#{root}step_modifier/"
    WorkflowStepTemplate: "#{root}workflow_step_templates/"
    WorkflowStep: "#{root}workflow_steps/"
    WorkflowStepIteration: "#{root}workflow_step_iterations/"
    ManualWorkflowStepIteration: "#{root}manual_workflow_step_iterations/"
    WorkflowStepIterationSearch: "#{root}workflow_step_iteration_searchs/"
    WorkflowStepIterationSearchResult: "#{root}workflow_step_iteration_search_datas/"
    ResearchRequest: "#{root}research_requests/"
    ResearchRequestMessage: "#{root}research_request_messages/"
    State: "#{root}states/"
    Processes: "#{root}processes/"
    Project: "#{root}projects/"
    ProjectEncryptedMetadata: "#{root}projects_encrypted_metadata/"
    ProjectStarredDocument: "#{root}project_starred_documents/"
    Comment: "#{root}comments/"
    Language: "#{root}language/"
    Country: "#{root}country/"
    Subdivision: "#{root}subdivision/"
    City: "#{root}city/"
    Category: "#{root}category/"
    Collection: "#{root}collection/"
    Engine: "#{root}engine/"
    AdverseTerms: "#{root}adverse_terms/"
    Search: "#{root}searches/"
    SearchWorker: "#{root}search_workers/"
    SearchResult: "#{root}search_results/"
    SearchTermTypes: "#{root}search_term_types/"
    ManagedUser: "#{root}managed_users/"
    SimpleManagedUser: "#{root}simple_managed_users/"
    ManagedGroup: "#{root}groups/"
    ManagedClient: "#{root}managed_clients/"
    CalculateRiskScore: "#{rpcRoot}calculate_risk_score/"
    Translate: "#{rpcRoot}translate/"
    User: "#{rpcRoot}user/"
    Users: "#{root}users/"
    Preferences: "#{root}preferences/"
    AssignProject: "#{rpcRoot}assign_project/"
    ProjectExports: "#{root}project_exports/"
    ProjectExportsDownloads: "#{root}project_exports_downloads/"
    ProjectPagination: "#{root}project-pagination/"
    CSRF: "#{rpcRoot}csrf/"
    FactivaToken: "#{rpcRoot}factiva_token/"
    MonitoringSubjects: "#{root}../../checks/api/v1/subjects/"
    ActionLog: "#{root}action_log/"
    AuditTrail: "#{root}audit_trail/"
    Entity: "#{root}entity/"
    FactTemplates: "#{root}fact_templates/"
    IDDReport: "#{root}idd_report/"
    NormanResult: "#{root}rpc/normanresult/"
    StickyMessage: "#{root}stickymessage/"
    BulkUpload: "#{root}bulkupload/"
    BulkUploadMappings: "#{root}bulkupload_mappings/"
    ExternalFactivaSession: settings.FACTIVA_AUTHENTICATE
    CustomSource: "#{root}custom_source/"
    CuratedSource: "#{root}curated_source/"
    NamePseudonyms: "#{twain}api/pseudonyms"
    RunIteration: "#{rpcRoot}run_iteration/"
  }
